import { render } from "./Commissions.vue?vue&type=template&id=1f88f77d&scoped=true"
import script from "./Commissions.vue?vue&type=script&lang=js"
export * from "./Commissions.vue?vue&type=script&lang=js"

import "./Commissions.vue?vue&type=style&index=0&id=1f88f77d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f88f77d"]])

export default __exports__